
import {createSlice} from "@reduxjs/toolkit";

export const platformSearchSlice = createSlice({
    name: 'platformSearchSlc',
    initialState: {value: {
            platformDrawerState: false, platformDrawerMode: null, platformGridRefresh: false
        }},
    reducers:

{
    changePlatformSearch: (state, action) => {
        state.value = {
            ...state.value,  // Keep existing fields
            ...action.payload // Merge new values
        };
    }
}
});

export const { changePlatformSearch } = platformSearchSlice.actions;

export default  platformSearchSlice.reducer ;
